/**
 * common Jackpot View
 */

define(function(require, exports, module) {
    'use strict';

    var JackpotView = require('replacers/jackpot/jackpot.view');
    var jackpotModel = require('replacers/jackpot/jackpot.model.instance');

    module.exports = JackpotView.extend({

        onSuccessJackpotResponse: function() {
            var modelData = jackpotModel.toJSON();
            var jackpot;

            if (this.jackpotCode) {
                jackpot = modelData.jackpots && modelData.jackpots[this.jackpotCode];
                jackpot = jackpot && jackpot[0];
            } else {
                if (modelData.total && modelData.total[0]) {
                    jackpot = modelData.total[0];
                    jackpot.amount = jackpot.jackpotAmount;
                }
            }

            jackpot && this.attachWidget(this.$('.jackpot-wrapper').ticker(jackpot));
        }
    });
});